<template>
    <newsletter-preferences-section
        class="newsletter-preferences-section-module"
        :title="attributes.newsletterPreferences_title"
        :text="attributes.text"
        :submit-button-text="attributes.submit_button_text"
        :success-title="attributes.success_title"
        :success-text="attributes.success_text"
        :interests="interests"
        :contact-data="attributes.asyncData.contactData"
        :locations="attributes.asyncData.locations"
    />
</template>

<script>
    import NewsletterPreferencesSection
        from '../../../organisms/NewsletterPreferencesSection/NewsletterPreferencesSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';
    import { ITSU_NEWSLETTER_CTC_ID_COOKIE_NAME } from '../../../../plugins/constants';

    export default {
        name: 'newsletter-preferences-section-module',

        components: { NewsletterPreferencesSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        async asyncData({ store, app }) {
            const ctcId = app.$cookies.get(ITSU_NEWSLETTER_CTC_ID_COOKIE_NAME);

            let contactData = {
                email: '',
                store_id: null,
                firstname: '',
                lastname: '',
                interests: [],
            };

            if (ctcId) {
                contactData = await store.dispatch('atreemo/newsletter/fetchPreferences', ctcId);
            }

            const locations = await store.dispatch('atreemo/locations/get');

            return {
                contactData,
                locations,
            };
        },

        computed: {
            /**
             * Format the interests.
             *
             * @returns {{name: string, icon: {alt: string, src: string, width: string, height: string}, key: string}[]}
             */
            interests() {
                return (this.attributes.interests || [])
                    .map((interest) => ({
                        name: interest.name,
                        key: interest.key,
                        icon: formatMediaObject.call(this, interest.icon),
                    }));
            },
        },
    };
</script>
